import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useMemo } from 'react';
import { useAsync } from 'react-use';
import { getOptionIdValueFromKeyword } from '@uno/common-cms';
import { getKeywords } from 'services/networking/semantic-score';

var useSemanticScore = function useSemanticScore(lang) {
  var _useAsync = useAsync( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getKeywords(lang);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [lang]),
      loading = _useAsync.loading,
      error = _useAsync.error,
      value = _useAsync.value;

  var options = useMemo(function () {
    return value ? value.map(function (keyword) {
      return {
        id: getOptionIdValueFromKeyword(keyword),
        title: keyword.keyword
      };
    }) : [];
  }, [value]);
  return {
    loading: loading,
    error: error,
    options: options
  };
};

export default useSemanticScore;